import { useEffect, useState } from "react"

import { 
  ContextualSidebar, 
  Footer, 
  Notification, 
  Sidebar, 
  TopNavbar 
} from "@components"

import { ArrowsPointingOutIcon } from "@heroicons/react/24/outline"
import PropTypes from "prop-types"

const MinResolutionMessage = () => (
  <div className="min-h-[calc(100vh-280px)] flex flex-col items-center justify-center h-full p-8 text-center">
    <ArrowsPointingOutIcon className="h-2/6 xl:h-3/6 w-auto max-w-[400px] text-content2-foreground" />

    <h1 className="my-3 text-3xl font-semibold text-foreground">We need more space</h1>
    <p className="text-content2-foreground">
      This application is optimized for devices with a screen width of 800 pixels or more. If you're seeing this message, your current screen width is below this threshold.​  To ensure the best user experience, please access the application on a device with a wider screen, such as a tablet, laptop, or desktop computer.
    </p>
  </div>
)

const Page = ({ backgroundImage = null, classNames = "", children }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 800)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 800)
    }

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return (
    <div className={`${classNames}`} style={{ backgroundImage: `url(${backgroundImage})` }}>
      <TopNavbar />

      <div className="flex pt-16">
        <ContextualSidebar />

        <Sidebar />

        <Notification />

        <div className="flex-grow overflow-auto">
          <main className="min-h-[calc(100vh-268px)] px-6">
            {isMobile && <MinResolutionMessage />}

            {!isMobile && <div>{children}</div>}
          </main>
        </div>
      </div>

      <Footer />
    </div >
  )
}

Page.propTypes = {
  backgroundImage: PropTypes.string,
  classNames: PropTypes.string,
  children: PropTypes.node.isRequired,
}

export default Page
